import { DisplayOption, displayOptionsMap } from '@/adapters/__project__/BuilderNavbarAdapter'
import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { BUILDER_DEVICES } from '@/shared/builder-constants'

import { useActiveDevice } from './useActiveDevice'

export const useBreakpoint = () => {
  const { navbarSettings } = useAppBuilderContext()

  const [device] = useActiveDevice()
  const activeBreakpoint = navbarSettings[device]

  const completeDisplayOptions = (
    displayOptions: DisplayOption[],
    displayOptionsMap: { name: string; label: string }[]
  ): DisplayOption[] => {
    const existingNames = new Set(displayOptions.map((option) => option.name))

    const updatedDisplayOptions = [
      ...displayOptions,
      ...displayOptionsMap
        .filter((mapOption) => !existingNames.has(mapOption.name))
        .map((mapOption) => ({
          name: mapOption.name,
          label: mapOption.label,
          checked: true,
        })),
    ]

    return updatedDisplayOptions
  }

  if (activeBreakpoint) {
    const displayOptions = completeDisplayOptions(activeBreakpoint.displayOptions || [], displayOptionsMap)
    activeBreakpoint.displayOptions = displayOptions
  }

  const isNavPositionLeading = activeBreakpoint?.position === 'leading'
  const isNavigationBarTop = activeBreakpoint?.position === 'top'
  const isNavigationBarBottom = activeBreakpoint?.position === 'bottom'

  const isPhonePortrait = device === 'phone'
  const isPhoneLandscape = device === 'phone-landscape'
  const isTabletPortrait = device === 'tablet'
  const isTabletLandscape = device === 'tablet-landscape'
  const isDesktop = device === 'desktop'
  const isTV = device === 'tv'

  const isPhone = isPhonePortrait || isPhoneLandscape
  const isTablet = isTabletPortrait || isTabletLandscape

  const menuHeight = activeBreakpoint?.menuHeight

  const activeViewportIcon = BUILDER_DEVICES[device].Icon

  const isIconDirectionVertical = activeBreakpoint?.iconDirection === 'vertical'
  const isIconDirectionHorizontal = activeBreakpoint?.iconDirection === 'horizontal'

  const getMenuWidth = (menuWidth: string | undefined) => {
    return menuWidth ?? '100px'
  }

  const getMenuHeight = (menuHeight: string | undefined) => {
    // if (isPhonePortrait) return '75px'
    return menuHeight ?? '80px'
  }

  const getNavbarDisplayOption = (name: string) => {
    return activeBreakpoint?.displayOptions?.find((option) => option.name === name)?.checked
  }

  const isSticky = getNavbarDisplayOption('sticky')

  const isShowNavbar = navbarSettings[activeBreakpoint?.viewport].show

  return {
    isNavPositionLeading,
    isNavigationBarTop,
    isNavigationBarBottom,
    isPhonePortrait,
    isPhoneLandscape,
    isTabletPortrait,
    isTabletLandscape,
    isDesktop,
    isTV,
    activeBreakpoint,
    isPhone,
    isTablet,
    isSticky,
    device,
    activeViewportIcon,
    isIconDirectionHorizontal,
    isIconDirectionVertical,
    getMenuWidth,
    getMenuHeight,
    getNavbarDisplayOption,
    menuHeight,
    isShowNavbar,
  }
}
